import Select from '@ben/orion/deprecated-select';
import { type IModularBenefitDetail } from '@ben/shared/types/columbia';
import { StartsOnEnum } from '@ben/shared/types/modular-benefit';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import styled, { css } from 'styled-components';

interface IEnrolmentStartsOnDate {
  index: number;
  control: Control<IModularBenefitDetail>;
  disabled?: boolean;
}

export const startsOnOptions = [
  { key: StartsOnEnum.EMPLOYMENT_START, label: 'Employment start' },
  { key: StartsOnEnum.ELIGIBILITY_START, label: 'Eligibility start' },
  { key: StartsOnEnum.PROBATION_END, label: 'Probation end' },
  { key: StartsOnEnum.POSTPONEMENT_END, label: 'Postponement window end date' },
  { key: StartsOnEnum.OPT_IN, label: 'Opt in' },
  { key: StartsOnEnum.ENROLLMENT_END, label: 'Enrollment end' },
  {
    key: StartsOnEnum.BEFORE_ENROLLMENT_END,
    label: 'Before enrollment end',
  },
  { key: StartsOnEnum.BENEFIT_START_DATE, label: 'Benefit start date' },
  { key: StartsOnEnum.LIFE_EVENT, label: 'Life event' },
  { key: StartsOnEnum.AGE_THRESHOLD, label: 'Age Threshold' },
];

const EnrolmentStartsOnDate = ({
  index,
  control,
  disabled = false,
}: IEnrolmentStartsOnDate) => {
  return (
    <Wrapper>
      <Controller
        name={`benefitWindows.${index}.startsOn`}
        control={control}
        render={({ field }) => (
          <Select
            {...field}
            options={startsOnOptions}
            disabled={disabled}
            name="Starts on"
          />
        )}
      />
    </Wrapper>
  );
};

export default EnrolmentStartsOnDate;

const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
  `}
`;
